var site = site || {};

(function ($) {
  site.EDD = site.EDD || {};

  site.EDD.whenWillMyOrderArrive = function (args) {
    $('.order_arrival #order_arrival_info a').hide();
    if (args.isShoppable) {
      $('.order_arrival #order_arrival_info a').show();
    }
    $('.order_arrival #order_arrival_info a').on('click', function (e) {
      e.preventDefault();
      $('.order_delivery_info .header, .order_delivery_info .body').hide();
      $('.invalid_zipcode').addClass('hidden');
      $('.content_with_zipcode').addClass('hidden');
      $('.content_without_zipcode').removeClass('hidden');
      generic.overlay.launch({
        content: $('.order_arrival_details_overlay').html(),
        includeBackground: true,
        cssClass: 'edd_popover',
        lockPosition: true,
        center: true, // one line required set
        onComplete: function () {
          $('.order_arrival_details .postal_code .apply')
            .off('click')
            .on('click', function (e) {
              e.preventDefault();
              site.EDD.showOrderArrivalDate();
            });
        }
      });
    });
    $('.order_arrival_details .postal_code .apply')
      .off('click')
      .on('click', function (e) {
        e.preventDefault();
        site.EDD.showOrderArrivalDate();
      });

    $('.order_arrival_details .postal_code #zipcode').on('keyup blur', function () {
      $(this).val(
        $(this)
          .val()
          .replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '')
      );
    });
  };

  site.EDD.showOrderArrivalDate = function (args) {
    var ctrlZipcode = $('.edd_popover .order_arrival_details .postal_code #zipcode');
    var zipcode = ctrlZipcode.val();

    generic.jsonrpc.fetch({
      method: 'address.estimateDeliveryDateSPP_v2',
      params: [
        {
          POSTAL_CODE: zipcode
        }
      ],
      onSuccess: function (jsonRpcResponse) {
        var body = $('.order_arrival_details .order_delivery_info .body');

        body.html('');
        body.hide();
        $('.order_delivery_info .header').show();
        var arrival_info = jsonRpcResponse.getValue();
        // arrival_info[0].using_zipcode
        var isValidZip = arrival_info[1].is_valid_zipcode;

        if (isValidZip) {
          $('.order_delivery_info').addClass('valid_zipcode');
          $('.invalid_zipcode').addClass('hidden');
          $('#colorbox').removeClass('empty_zipcode').addClass('zipcode');
          $('.content_with_zipcode').removeClass('hidden');
          $('.content_without_zipcode').addClass('hidden');
        } else {
          $('.invalid_zipcode').removeClass('hidden');
          $('.order_delivery_info').removeClass('valid_zipcode');
          $('#colorbox').addClass('empty_zipcode').removeClass('zipcode');
          $('.content_with_zipcode').addClass('hidden');
          $('.content_without_zipcode').removeClass('hidden');
        }
        // Sorting shipment type as per spec
        var display_order = [
          'us_nextday',
          'us_2day',
          'us_std',
          'us_std_exact',
          'us_territory',
          'us_mil_pobox',
          'mx_std'
        ];

        for (iCnt = 0; iCnt < display_order.length; iCnt++) {
          for (jCnt = 2; jCnt < arrival_info.length; jCnt++) {
            if (arrival_info[jCnt].type == display_order[iCnt]) {
              arrival_info[jCnt].shipment_type = $('.' + arrival_info[jCnt].type).text();
              arrival_info[jCnt].arrival_date =
                arrival_info[jCnt].min_day_name +
                ' ' +
                arrival_info[jCnt].min_mon +
                '/' +
                arrival_info[jCnt].min_day_num;

              if (arrival_info[jCnt].max_day_name) {
                arrival_info[jCnt].arrival_date +=
                  ' - ' +
                  arrival_info[jCnt].max_day_name +
                  ' ' +
                  arrival_info[jCnt].max_mon +
                  '/' +
                  arrival_info[jCnt].max_day_num;
              }

              generic.template.get({
                path:
                  '/sites/esteelauder/themes/estee_base/template_api/_partials/product_edd_mobile_v3/estimated_delivery_date.mustache',
                object: arrival_info[jCnt],
                callback: function (html) {
                  body.append(html);
                }
              });
              break;
            }
          }
        }
        body.show();
      },
      onFailure: function (jsonRpcResponse) {
        // console.log(jsonRpcResponse.getError());
        console.log('Failed to get zip code information');
      }
    });
  };
})(jQuery);
